import React, { Fragment } from 'react'
import styles from './MonthPicker.scss'
import { PopoverMenu } from 'common/styleguide/PopoverMenu'
import moment from 'moment'
import _ from 'lodash'

export class MonthPicker extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false
    }
  }

  showPopover = () => {
    this.setState({ expanded: true })
  }

  hidePopover = () => {
    this.setState({ expanded: false })
  }

  valueChanged = (e) => {
    const { date, dateChanged } = this.props

    const unit = e.target.name
    const value = e.target.value

    dateChanged(moment(date).set(unit, value))
  }

  render () {
    const { children, date } = this.props
    const { expanded } = this.state

    return (
      <Fragment>
        <div
          className={styles.pickerLink}
          ref={r => { this._pickerLink = r }}
          onClick={this.showPopover}>
          {children}
        </div>
        {expanded && <PopoverMenu
          target={this._pickerLink}
          container={window.body}
          placement='bottom'
          className={styles.MonthPicker}
          onRequestClose={this.hidePopover}>
          <select style={{ marginRight: '5px' }} name='month' value={moment(date).month()} onChange={this.valueChanged}>
            {moment.months().map((m, i) => <option key={i} value={i}>{m}</option>)}
          </select>
          <select name='year' value={moment(date).year()} onChange={this.valueChanged}>
            {_.reverse(_.range(2000, moment().year() + 2)).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </PopoverMenu>}
      </Fragment>
    )
  }
}
